import { useEffect, useContext } from "react";
import { CommonServiceContext } from "../../../services/common/commonService";
import Loader from "../../../components/Loader";
import TextWithBreaks from "../../../components/common/TextWithBreaks";

const Terms = () => {
  const { getTerms, terms, loading } = useContext(CommonServiceContext);

  const getTermsContent = async () => {
    await getTerms();
  };

  useEffect(() => {
    getTermsContent();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <section id="terms" className="py-10 lg:py-20 mt-80">
        <div className="container">
          <div className="mb-10 flex items-end justify-between">
            <div className="mx-auto max-w-2xl text-center">
              <span className="rounded-md border border-primary bg-primary/20 px-3 py-1 text-xs font-medium uppercase tracking-wider text-primary">
                წესები და პირობები
              </span>
            </div>
          </div>
          <section className="flex items-start justify-between h-auto ">
            <div className="w-full bg-white p-6 shadow-lg rounded-lg">
              <h2 className="text-2xl font-semibold text-gray-800">
                {terms?.name}
              </h2>
              <h4 className="mt-4 text-gray-600">
                <TextWithBreaks text={terms?.text} />
              </h4>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};
export default Terms;
